import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorUrlResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorUrl: metadata.getAuthorUrl() } as StreamData)

export default authorUrlResolver
